import {User} from "./User";

export const AddUserFormTemplate = Object.freeze({
    sections: [
        {
            size: 1/2,
            compact: true,
            inputs: [
                User.name,
                User.email,
            ]
        },{
            size: 1/4,
            compact: true,
            inputs: [
                User.age,
                User.gender,
                User.height,
                User.weight,
            ]
        },{
            size: 1/2,
            compact: true,
            inputs: [
                User.password,
                User.passwordVerification,
            ]
        },
    ]
});